import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import type { BaseResponse } from '../models'
import { readToken } from '../token/token'

const _BASE_URL = import.meta.env.REACT_APP_AUTH_API_BASE_URL!

export interface LoginToDocsRequest {
  redirect: string
}

export interface LoginToDocsResponse {
  redirectUrl: string
}

export const docsAuthApi = createApi({
  reducerPath: 'docsAuthApi',
  baseQuery: fetchBaseQuery({
    baseUrl: _BASE_URL,
    prepareHeaders: (headers) => {
      const token = readToken()
      if (token) {
        headers.set('Authorization', `Bearer ${token.accessToken}`)
      }
      return headers
    },
  }),
  tagTypes: ['docs'],
  endpoints: (builder) => ({
    loginToDocs: builder.mutation<BaseResponse<LoginToDocsResponse>, LoginToDocsRequest>({
      query: (body) => ({
        url: `/v2/console/login-to-docs`,
        method: 'POST',
        body,
      }),
      invalidatesTags: [],
    }),
  }),
})

export const { useLoginToDocsMutation } = docsAuthApi
